export const AndroidIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M17.6 9.48l1.84-3.18a.4.4 0 00-.14-.55.4.4 0 00-.55.14l-1.86 3.22a11.4 11.4 0 00-9.78 0L5.25 5.89a.4.4 0 00-.55-.14.4.4 0 00-.14.55L6.4 9.48C3.3 11.16 1.28 14.3.9 18h22.2c-.38-3.7-2.4-6.84-5.5-8.52zM7.5 15.2a1.15 1.15 0 110-2.3 1.15 1.15 0 010 2.3zm9 0a1.15 1.15 0 110-2.3 1.15 1.15 0 010 2.3z" />
  </svg>
);

export const AppleIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M16.37 1.43c0 1.05-.43 2.09-1.13 2.84-.75.82-1.98 1.45-3 1.37a3.4 3.4 0 01.87-2.66c.74-.85 2.02-1.48 3.09-1.55.03.32.17.66.17 0zm3.9 15.61c-.02.06-.44 1.53-1.48 3.04-.9 1.31-1.84 2.61-3.32 2.63-1.45.03-1.92-.86-3.58-.86-1.66 0-2.18.83-3.55.89-1.43.05-2.51-1.41-3.42-2.71-1.86-2.69-3.28-7.6-1.37-10.91a5.1 5.1 0 014.3-2.62c1.4-.03 2.72.94 3.58.94.85 0 2.46-1.16 4.15-.99.7.03 2.68.29 3.95 2.13-.1.06-2.36 1.38-2.33 4.12.03 3.27 2.87 4.36 2.9 4.37z" />
  </svg>
);
